import { DocumentoTipoRequisito, eEstadoDocumento, SolicitudSeccion } from "../common/enumModel";
import { IConfiguracionDocumentoUpdateModel } from "../interfaces/configuracion-documento/IConfiguracionDocumentoUpdateModel";

export class ConfiguracionDocumentoUpdateModel implements IConfiguracionDocumentoUpdateModel {
    idConfiguracionDocumento: number;
    idMaestroDocumento: number;
    idTipoVisita: number;
    idRequisito : DocumentoTipoRequisito;
    esPredeterminado: boolean;
    controlarFechas: boolean;
    restringeAccesos: boolean;
    seccion: SolicitudSeccion;
    idEstado: eEstadoDocumento;

    constructor(){
        this.idConfiguracionDocumento = 0;
        this.idMaestroDocumento = 0;
        this.idTipoVisita = 0;
        this.idRequisito = DocumentoTipoRequisito.TODOS;
        this.esPredeterminado = false;
        this.controlarFechas = false;
        this.restringeAccesos = false;
        this.seccion = SolicitudSeccion.Personal;
        this.idEstado = eEstadoDocumento.ACTIVO;
    }
}